import SaladToggleButton from 'components/input/SaladToggleButton';
import React, { useEffect, useState } from 'react';
import { FilterContainer, FilterHeader } from 'resources/styles/TableStyle';

import styled, { createGlobalStyle } from 'styled-components';
import { Button, InputField, Row } from 'saladsoft-primitive';
import { ReservationDailyFilterType } from 'types/CommonTypes';
import { useStoreWrapper } from 'stores/StoreHelper';
import moment from 'moment';
import { PageTitle } from 'resources/styles/TableStyle';
const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 10px !important;
  }

`;

const ReservationDailyFilter = ({
  onclick,
}: {
  onclick: (search: ReservationDailyFilterType) => void;
}) => {
  const { reservationFilterStore } = useStoreWrapper();
  const today = moment().format('YYYY-MM-DD');

  const [defaultIndex, setDefaultIndex] = useState(0);

  const handleChangeType = (value: string) => {
    if (value === null) {
      return;
    }
    setDefaultIndex(items.findIndex((item) => item.value === value));
    onclick({
      type: value as ReservationDailyFilterType['type'],
      date: reservationFilterStore.dailyConditions.date,
    });
  };

  const items = [
    { value: 'all', label: '전체' },
    { value: 'arrival', label: '입실' },
    { value: 'departure', label: '퇴실' },
  ];

  useEffect(() => {
    setDefaultIndex(0);
  }, [reservationFilterStore?.reservations]);

  useEffect(() => {
    reservationFilterStore.getReservationByDaily({
      type: 'all',
      date: today,
    });
  }, []);

  return (
    <div>
      <GlobalInputStyle />
      <Row justifyContent="space-between" width="100%">
        <FilterContainer>
          <PageTitle>일별 예약조회</PageTitle>
          <FilterHeader>
            <SaladToggleButton
              defaultIndex={defaultIndex}
              items={items}
              onChange={handleChangeType}
            />
          </FilterHeader>
          <div style={{ maxWidth: 450, width: '100%' }}>
            <InputWrapper
              placeholder="게스트명, 예약번호, 이메일, 전화번호"
              onChange={(value: string) => {
                reservationFilterStore.setFilterByKeyword(value);
              }}
              style={{ padding: 0 }}
            />
          </div>
        </FilterContainer>
      </Row>
    </div>
  );
};

const InputWrapper = styled(InputField)`
  border-radius: 10px !important;
  > div {
    padding: 0px !important;
    margin: 0px !important;
    border-radius: 10px !important;
  }
`;

export default ReservationDailyFilter;
